import { ArrowLeft, ArrowRight } from "@mui/icons-material";
import { Stack } from "@mui/material";
import "./style.css";

function CustomPagination({ count, page, onChangePage, totalRecord, data, totalPage, itemsPerPage }) {
	return (
		<Stack direction="row" spacing={2} alignItems={"center"} justifyContent="center" mt={2}>
			<button
				className={page === 1 ? "pagination-btn arrow-disabled" : "arrow"}
				disabled={page === 1}
				onClick={() => onChangePage(null, page - 1)}
			>
				<ArrowLeft />
			</button>
			<div className="pagination-page d-flex align-items-center">
				<span className="page">{page}</span>
			</div>

			<button
				className={
					data?.length === 0 || (totalPage > 0 && page + 1 > totalPage)
						? "pagination-btn arrow-disabled"
						: "arrow"
				}
				disabled={data?.length === 0 || (totalPage > 0 && page + 1 > totalPage)}
				onClick={(e) => {
					onChangePage(e, page + 1);
				}}
			>
				<ArrowRight />
			</button>
		</Stack>
	);
}

export default CustomPagination;

/* <button className="pagination-btn" onClick={() => onChangePage(null, page + 1)}> */
